// extracted by mini-css-extract-plugin
export default {"text":"TaskCounter_text__xV-LU"};